import {RequestStatus} from "../../utils/Enums";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiClient} from "../../utils/ApiClient";
import User from "../../models/User";

interface InfoState {
    inquiriesToday: any[];
    managedLoadings: any[];
    managedRailroadAndSea: any[];
    managedRoad: any[];
    nextUser: User | null;
    me: User | null;
    unpaid: any[];
    insurance: any[];
    settings: any;
    getTodayStatus: RequestStatus;
}

const initialState: InfoState = {
    inquiriesToday: [],
    managedLoadings: [],
    managedRailroadAndSea: [],
    managedRoad: [],
    nextUser: null,
    me: null,
    unpaid: [],
    insurance: [],
    settings: {},
    getTodayStatus: RequestStatus.Idle
}

export const getToday = createAsyncThunk(
    'info/getToday',
    async (_, {rejectWithValue}) => {
        const response = await apiClient.get('info/today');
        return response.data;
    }
);

const infoSlice = createSlice({
    name: 'info',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getToday.pending, (state) => {
                state.getTodayStatus = RequestStatus.Loading;
            })
            .addCase(getToday.fulfilled, (state, action) => {
                state.getTodayStatus = RequestStatus.Success;
                state.inquiriesToday = action.payload.inquiriesToday;
                state.managedLoadings = action.payload.managedLoadings;
                state.managedRailroadAndSea = action.payload.managedRailroadAndSea;
                state.managedRoad = action.payload.managedRoad;
                state.nextUser = action.payload.nextUser;
                state.unpaid = action.payload.unpaid;
                state.insurance = action.payload.insurance;
                state.me = action.payload.me;
                state.settings = action.payload.settings;
            })
            .addCase(getToday.rejected, (state, action) => {
                state.getTodayStatus = RequestStatus.Failed;
            });
    },
});

export default infoSlice.reducer;